import React, { useState, useEffect, useRef, useMemo } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import "../common.css";
import "./style.css";
import LoadingOverlay from "react-loading-overlay";
import { verifyAccessPermission } from "../../../utils/rolePermissionAccess";
import * as manageuserConsts from "../Common/usermanagementconst";
import MappingDunsModal from "./MappingDunsModal";
import Cookie from "js-cookie";
import {
  SelectFieldReactComp,
  getPrepareOptionsForReactDp,
} from "../Common/formfields";
import {
  httpGetManageUserParentChildList,
  httpGetManageUserParentChildHierarchy,
  httpPostParentChildConfirmation,
  httpGetParentDunsForSelectedVendor,
  httpGetConfigValues,
  httpGetDvnByChildVendorId
} from "../../../service/httpClient";
import { updateCommonInfo } from "../../../redux/commonSlice";
import { AgGridReact } from "ag-grid-react";
import * as Constants from "../../../constants/Constants";
import { VendorGrid } from "./relationshiphierarchy";

const ParentChildDunsMapping = () => {
  const store = useSelector(
    ({ service, common }) => ({
      profileId: common.profileId,
      duns: common.duns,
      vendorCorpName: common.vendorCorpName,
      vendorConfig: common.configValues,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const gridRef = useRef();
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  
  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
    resizable: true,
    filter: true,
    suppressNavigable: true,
    cellClass: "no-border",
    cellStyle: { "justify-content": "center" },
  }));
  
  const [parentOptions, setParentOptions] = useState([]);
  const [childOptions, setChildOptions] = useState([]);
  const [relationshipTypeOptions, setRelationshipTypeOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dunsHierarchy, setDunsHierarchy] = useState([]);
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  let selectedDvns = new Array();

  const dvnCellRenderer = (props) => {
    const [checked, setChecked] = useState(props.value);
    const [dvns, setDvns] = useState([]);
    const handleClick = (e) => {      
      const data = props?.data;
      data.isChecked = !checked;
      if(!selectedDvns.includes(data) && data?.isChecked) {
        selectedDvns.push(data);
      } else if (selectedDvns.includes(data) && !data?.isChecked) {
        selectedDvns = selectedDvns.filter((items) => items.deptNumber !== data?.deptNumber);
      } else if (!selectedDvns.includes(data) && !data?.isChecked){
        selectedDvns.push(data);
      }
    
      setChecked(!checked);
    }

    return (
      <>
        <input type="checkbox" name="dvnSelected" id="dvnSelected" value="" checked={checked} onClick={(e) => handleClick(e)}/>
      </>
    )
  };

  const initialState = {
    defaultParentList: [],
    defaultChildList: [],
    parentCompanies: [],
    childCompanies: [],
    relationshipType: [],
  };
  const [formValues, setFormValues] = useState({
    ...initialState,
    prev: initialState,
  });
  const validateSubmitDuns = () => {
    const {
      parentCompanies = [],
      childCompanies = [],
      relationshipType = [],
    } = formValues;
    return (
      parentCompanies?.length === 0 ||
      childCompanies?.length === 0 ||
      relationshipType?.length === 0
    );
  };

  const handleParentChange = (selectedOption) => {
    const { value: duns, label: vendorCorp, addonParms } = selectedOption;
    let itemToBeRemoved = [duns];
    // Check for any parent vendors for the selected parent, and return the duns list if found
    checkParentDunsExistForSelectedVendor(
      selectedOption.value,
      itemToBeRemoved,
      selectedOption
    );

    //Update Hierarchy on parent change
    getParentChildHierarchy(duns, addonParms?.vendorCorpName, itemToBeRemoved);
  };

  const checkParentDunsExistForSelectedVendor = (
    duns,
    itemToBeRemoved,
    selectedOption
  ) => {
    console.log(
      "Checking parent duns exist for the selected duns from parent list",
      duns
    );
    setFormValues({
      ...formValues,
      parentCompanies: [selectedOption],
      childCompanies: [],
      relationshipType: [],
    });
    // filter child options before displaying on UI except parent selected
       
    return httpGetParentDunsForSelectedVendor("parent", duns)
      .then((response) => {
        let rsData = response?.data?.vendors || false;
        let opt = getPrepareOptionsForReactDp(
          rsData,
          "duns",
          "vendorCorpNameDuns"
        );

        //Filter Child Dp to remove selected parents child elem
        let filteredChildOpt = opt?.filter((opt) => {
          return !itemToBeRemoved.includes(opt?.value);
        });

        setChildOptions(filteredChildOpt);
      })
      .catch((error) => {
        return error;
      });
  };

  const handleChildChange = (selectedOption) => {
    setError(false);
    setErrorMessage("");
    //check if selected parent and child are same then prevent child state update
    if (
      formValues?.parentCompanies?.some((e) => e.value === selectedOption.value)
    ) {
      setError(true);
      setErrorMessage(manageuserConsts.MSG_PARENT_CHILD_CANT_BE_SAME);
      return;
    }

    setFormValues({
      ...formValues,
      childCompanies: [selectedOption],
      dvns: [],
      relationshipType: [],
    });
  };

  const getFormFieldsColumns = () => {
    return [
      {
        headerName: "Select DVN",
        cellRenderer: dvnCellRenderer,
        field: "isChecked",
        flex:1
      },
      {
        headerName: "Operating Division",
        field: "operatingDivision",
        flex:1
      },
      {
        headerName: "Department Number",
        field: "deptNumber",
        flex:1
      },
      {
        headerName: "Vendor Number",
        field: "vendorNumber",
        flex:1
      },
      {
        headerName: "DVN Name",
        field: "dvnName",
        flex:1,
        hide: true
      }
    ]
  }

  const callToGetDvnByChild = (relationshipType) => {
    const {childCompanies = [], parentCompanies = []} = formValues;
    setColumnDefs(getFormFieldsColumns());
    setRowData([]);
   
    httpGetDvnByChildVendorId(parentCompanies[0]?.addonParms?.vendorProfileId,childCompanies[0]?.addonParms?.vendorProfileId, relationshipType).then(response => {
      
      setRowData(response.data);
    }).catch(error => {
      console.log(JSON.stringify(error));
    })
  };

  const handleRelationshipTypeChange = (selectedOption) => {
    if(selectedOption?.label === "MMG") {
      callToGetDvnByChild("MMG")
      setFormValues({
        ...formValues,
        relationshipType: [selectedOption],
        dvns: selectedDvns
      });
    } else {
      setFormValues({
        ...formValues,
        relationshipType: [selectedOption],
        dvns: []
      });
    }    
  };

  const handleClick = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleSave = () => {
    const {
      parentCompanies = [],
      childCompanies = [],
      dvns,
      relationshipType = [],
    } = formValues;
    const payload = {};
    payload.parentVendor = parentCompanies[0]?.addonParms;
    payload.childVendor = childCompanies[0]?.addonParms;
    payload.dvns = dvns;
    payload.relationshipType = relationshipType[0]?.value;
    payload.createdBy = Cookie.get("email");
    setIsLoading(true);
    setShow(false);
    httpPostParentChildConfirmation(payload)
      .then((res) => {
        //reset child dp as element added to the hierarchy
        setFormValues({
          ...formValues,
          childCompanies: [],
        });
        getParentChildListByType(manageuserConsts.OPT_PARENT).then((res) => {
          let parentList = typeof res !== "undefined" ? res : [];
          setFormValues({
            ...formValues,
            defaultParentList: parentList,
          });
          setParentOptions(parentList);
        });
        getParentChildListByType(manageuserConsts.OPT_CHILD).then((res) => {
          let childList = typeof res !== "undefined" ? res : [];
          setFormValues({
            ...formValues,
            defaultChildList: childList,
          });
          setChildOptions(childList);
        });

        getParentChildHierarchy(
          parentCompanies[0]?.addonParms?.duns,
          parentCompanies[0]?.addonParms?.vendorCorpName
        );
        setError(false);
        setErrorMessage("");
        //setIsLoading(false);
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          setErrorMessage(err?.response?.data?.message);
        } else if (err?.response?.status === 500) {
          setErrorMessage(manageuserConsts.MSG_ERROR_PARENT_CHILD_FAIL);
        } else {
          setErrorMessage(err.message);
        }
        setError(true);
        setIsLoading(false);
      });
  };

  const getParentChildListByType = (type) => {
    return httpGetManageUserParentChildList(type)
      .then((res) => {
        let rsData = res?.data?.vendors || false;
        let opt = getPrepareOptionsForReactDp(
          rsData,
          "duns",
          "vendorCorpNameDuns"
        );
        return opt;
      })
      .catch((error) => {
        return error;
      });
  };

  const getParentChildHierarchy = (duns, vendorCorp, prevItemToBeRemoved) => {
    setError(false);
    setErrorMessage("");
    setIsLoading(true);
    return httpGetManageUserParentChildHierarchy(duns, vendorCorp)
      .then((res) => {
        const { data: resObjHierarchy } = res;
        if (resObjHierarchy) {
          //get list of duns of all the childVendors
          let itemToBeRemovedHier = resObjHierarchy?.childVendor.map(function(
            el
          ) {
            return el.duns;
          });

          let itemToBeRemoved =
            typeof prevItemToBeRemoved !== "undefined"
              ? [...prevItemToBeRemoved, ...itemToBeRemovedHier]
              : [...itemToBeRemovedHier];

          //Filter Child Dp to remove selected parent elem
          let filteredChildOpt = formValues?.defaultChildList.filter((opt) => {
            return !itemToBeRemoved.includes(opt?.value);
          });
          setChildOptions(filteredChildOpt);

          setDunsHierarchy([resObjHierarchy]);
          setIsLoading(false);
          return resObjHierarchy;
        }
        setDunsHierarchy([]);
        setIsLoading(false);
        return false;
      })
      .catch((error) => {
        setDunsHierarchy([]);
        setIsLoading(false);
        return error;
      });
  };

  const getSelectedRelationShipOptionLabel = (
    relationshipTypeOptions,
    relationshipType
  ) => {
    for (const option of relationshipTypeOptions) {
      if (option.value === relationshipType) {
        return option.label;
      }
    }
    return null;
  };

  useEffect(() => {
    setIsLoading(true);
    if (store?.configValues === undefined) {
      httpGetConfigValues()
        .then((response) => {
          dispatch(
            updateCommonInfo({
              configValues: response.data,
            })
          );

          const vendorRelationShipTypes = response.data.filter(
            (config) =>
              config.key === manageuserConsts.VENDOR_RELATIONSHIP_OPTIONS_KEY
          );
          let vendorRelationshipOptions;
          if (vendorRelationShipTypes.length > 0) {
            const vendorRelationships = vendorRelationShipTypes[0].value;
            vendorRelationshipOptions = JSON.parse(vendorRelationships).map(
              (each) => {
                return {
                  label: each.value,
                  value: each.name,
                };
              }
            );

            setRelationshipTypeOptions(vendorRelationshipOptions);
          }
        })
        .catch((err) => console.log(err));
    }

    const { duns, vendorCorpName } = store || {};

    let promises = [];
    if (verifyAccessPermission("manageUsersParentChildDunsEdit")) {
      promises.push(getParentChildListByType(manageuserConsts.OPT_PARENT));
      promises.push(getParentChildListByType(manageuserConsts.OPT_CHILD));
    }
    if (duns && vendorCorpName) {
      promises.push(getParentChildHierarchy(duns, vendorCorpName));
    }
    try {
      Promise.all(promises).then((res) => {
        let parentList = typeof res[0] !== "undefined" ? res[0] : [];
        let childList = typeof res[1] !== "undefined" ? res[1] : [];
        setFormValues({
          ...formValues,
          defaultParentList: parentList,
          defaultChildList: childList,
        });
        setParentOptions(parentList);
        setChildOptions(childList);
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }, []);

  const ParentChildDunsHierarchy = () => {
    return verifyAccessPermission("manageUsersParentChildDunsView") ? (
      <div className="relation-hier">
        {Object.keys(dunsHierarchy).length > 0 ? (
           <VendorGrid pcHierData={dunsHierarchy} setIsLoading={setIsLoading} />
        ) : (
          <span className="no-data">{manageuserConsts.NO_DATA}</span>
        )}
      </div>
    ) : (
      manageuserConsts.MSG_NOT_AUTHORIZED_TO_ACCESS
    );
  };
  const { parentCompanies = [], childCompanies = [], relationshipType=[] } = formValues;
  return (
    <LoadingOverlay active={isLoading} spinner>
      <div className="top-container1">
        {error && <div className="cls-err cls-margin">{errorMessage}</div>}
        <div>
          <MappingDunsModal
            handleClose={handleClose}
            handleSave={handleSave}
            title={manageuserConsts.LABEL_CONFIRM_DUNS_RELATION}
            parentData={
              parentCompanies?.length && `${parentCompanies[0].label}`
            }
            childData={childCompanies?.length && `${childCompanies[0].label}`}
            show={show}
            cls="parent-child-duns"
          />
          {verifyAccessPermission("manageUsersParentChildDunsEdit") && (
            <div style={{
              borderBottom: "1px solid lightgray",
              borderRadius: "5px",
              background: "#d3d3d380"
            }}>
            <div className="main">
              <div className="parent-duns main-cnt">
                <div className="parent">
                  <SelectFieldReactComp
                    options={parentOptions}
                    placeholder={manageuserConsts.LBL_DUNS_DP}
                    onChange={handleParentChange}
                    value={formValues?.parentCompanies || ""}
                    isMulti={false}
                    openOnFocus={true}
                    id="parentdp"
                    label={manageuserConsts.LBL_PARENT_COMP}
                    required={true}
                    toolTipText={manageuserConsts.LBL_PARENT_COMP}
                  />
                </div>
                <div className="child">
                  <SelectFieldReactComp
                    options={childOptions}
                    placeholder={manageuserConsts.LBL_DUNS_DP}
                    onChange={handleChildChange}
                    value={formValues?.childCompanies || ""}
                    isMulti={false}
                    openOnFocus={true}
                    id="parentdp"
                    label={manageuserConsts.LBL_CHIELD_COMP}
                    required={true}
                    toolTipText={manageuserConsts.LBL_CHIELD_COMP}
                  />
                </div>
                <div className="child">
                  <SelectFieldReactComp
                    options={relationshipTypeOptions} //Need to change
                    placeholder={manageuserConsts.LBL_VENDOR_RELATION_PH}
                    onChange={handleRelationshipTypeChange}
                    value={formValues?.relationshipType || ""}
                    isMulti={false}
                    openOnFocus={true}
                    id="relationshipType"
                    label={manageuserConsts.LBL_VENDOR_RELATION}
                    required={true}
                    toolTipText={manageuserConsts.LBL_VENDOR_RELATION_TT}
                  />
                </div>
                
                <div className="save">
                  <button
                    className= {!validateSubmitDuns() ? "btn-pc-submit create-btn mt18" : "btn-pc-submit-disabled create-btn mt18" }
                    style={{ width: "100px" }}
                    disabled={validateSubmitDuns()}
                    onClick={handleClick}
                  >
                    {manageuserConsts.BTN_SUBMIT}
                  </button>
                </div>
              </div>
              
            </div>
              {relationshipType[0]?.label === "MMG" &&
                <div style={{
                  paddingLeft: "28px",
                  marginBottom: "12px",
                  width: "85%"
                }}>
                  <div className="ag-theme-balham dvn-grid-container">
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData}
                      columnDefs={columnDefs}
                      defaultColDef={defaultColDef}
                      animateRows={true}
                      rowSelection="multiple"
                      overlayNoRowsTemplate={
                        rowData?.length > 0 ? "" : Constants.NO_DATA_AVAILABLE
                      }
                    />
                  </div>
                </div>
              }
            </div>
          )}
          <ParentChildDunsHierarchy />
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default ParentChildDunsMapping;
